// extracted by mini-css-extract-plugin
export var attribution = "_ca-4";
export var authorName = "_ca-5";
export var quote = "_ca-3";
export var testimonial = "_ca-2";
export var trustedBy = "_ca-0";
export var trustedByLabel = "_ca-1";